import styled from 'styled-components';

export const CurveWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 380px;
  overflow: hidden;
  margin-top: -50px;

  @media(max-width: 499px){
    height: 200px;
  }
`;

export const Arc = styled.div<{ color: string; topOffset?: string }>`
  position: absolute;
  top: ${({ topOffset }) => topOffset || 0};
  left: 0;
  width: 100%;
  height: 380px;
  color: ${({ color }) => color};

  svg {
    width: 100%;
    height: 100%;
  }

  path {
    fill: currentColor;
  }

  @media(max-width: 499px){
    height: 200px;
    top: ${({ topOffset }) => topOffset ? "50px":0};
  }
`;
